import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroMovies } from '@/mocks/movies';

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const total = heroMovies.length;

  const goNext = useCallback(() => {
    setCurrent((prev) => (prev + 1) % total);
  }, [total]);

  const goPrev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(goNext, 5000);
    return () => clearInterval(timer);
  }, [goNext]);

  const movie = heroMovies[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {heroMovies.map((m, index) => (
        <div
          key={m.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <img
            src={m.cover}
            alt={`${m.title} - 被窝网电影高清免费在线观看`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/60" />
        </div>
      ))}

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-3xl" key={movie.id}>
            <div className="flex items-center gap-3 mb-4">
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50 whitespace-nowrap">
                <i className="ri-fire-line" />
                热门推荐
              </span>
              <span className="text-sm text-background-100/90">{movie.year}</span>
              <span className="text-sm text-background-100/90">{movie.duration}</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4">
              {movie.title}
            </h1>
            <p className="text-sm md:text-base text-background-200/90 leading-relaxed mb-6 line-clamp-2 max-w-xl">
              {movie.description}
            </p>

            <div className="flex items-center gap-3 flex-wrap">
              <Link
                to={`/movie/${movie.id}`}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg" />
                立即观看
              </Link>
              <Link
                to={`/category/${movie.categorySlug}`}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-50/20 text-background-50 font-medium text-sm backdrop-blur-sm hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apps-2-line text-lg" />
                更多{movie.category}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={goPrev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 hover:bg-background-50/40 transition-colors cursor-pointer"
        aria-label="上一个"
      >
        <i className="ri-arrow-left-s-line text-xl" />
      </button>
      <button
        onClick={goNext}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 hover:bg-background-50/40 transition-colors cursor-pointer"
        aria-label="下一个"
      >
        <i className="ri-arrow-right-s-line text-xl" />
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroMovies.map((m, index) => (
          <button
            key={m.id}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              index === current
                ? 'bg-primary-500 w-6'
                : 'bg-background-50/40 hover:bg-background-50/70'
            }`}
            aria-label={`切换到第${index + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}